export default __webpack_public_path__ + "static/media/AVAX.1b6b3fb1.svg";